import styled, { css } from 'styled-components';

import {
    Text,
    Spacer,
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledSpacer = styled(Spacer)`
    ${props => props.isClickable && css`
        cursor: pointer;
        &:hover {
            > * {
                color: ${token('colors.blue300')} !important;
            }
        }
    `}
`;

export const StyledText = styled(Text)`
    text-transform: uppercase;
    padding-bottom: ${spaceMixin('xs')};
`;
